export function topographyViewerIdFromLocation() {
  const id = new URLSearchParams(window.location.search).get('topo');
  if (!id || !/^\d+$/.test(id)) return null;
  return id;
}

export function openTopographyViewerTab(topographyId) {
  const url = `${window.location.origin}${window.location.pathname}?topo=${encodeURIComponent(topographyId)}`;
  window.open(url, '_blank', 'noopener');
}
